<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						기관등록
					</h2>
					<a class="close" @click="$emit('close')">&times;</a>
				</div>
				<div class="modal-body p-10 clearfix" style="min-height: 100px;background-color: #f8f8f8;">
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								기관코드
							</span>
							<input class="form-control full-width b-l-0" type="text" v-model="agency.agencyCode">
						</div>
					</div>
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								기관명
							</span>
							<input class="form-control full-width b-l-0" type="text" v-model="agency.agencyName">
						</div>
					</div>
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								직장주소
							</span>
							<input class="form-control full-width b-l-0 m-r-5"
								type="text" v-model="agency.agencyZipcode">
							<span class="input-group-addon button v-mid text-white">
								<button class="btn btn-red round m-l-5" @click="openAddressSearch">우편검색</button>
							</span>
						</div>
					</div>
					<div class="round m-b-10">
						<div class="input-group full-width">
							<input class="form-control full-width round" type="text" v-model="agency.agencyAddr" placeholder="기본주소">
						</div>
					</div>
					<div class="round m-b-10">
						<div class="input-group full-width">
							<input class="form-control full-width round" type="text" v-model="agency.agencyDetailAddr" placeholder="상세주소">
						</div>
					</div>
				</div>
				<div class="modal-footer p-10" style="background-color: #f8f8f8;">
					<button class=" btn bg-deepblue full-width text-white round" @click="postAgency()">등록</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import Axios from 'axios';
import server from '../statics/server';
import fnInstitutionValidator from '../mixins/fnInstitutionValidator';
import fnAddressSearch from '../mixins/fnAddressSearch.js'

export default {
	name: "ModalInstitutionRegister",
	mixins: [fnInstitutionValidator, fnAddressSearch],
	data:  function() {
		return {
			agency: {
				agencyCode: "",
				agencyZipcode: "",
				agencyName: "",
				agencyAddr: "",
				agenctDetailAddr: ""
			}
		}
	},
	default: function() {
		return {
			name: this.name,
			show: false
		}
	},

	props: {
		config: Object
	},

	methods: {
		// 주소 검색 모달
		findAddr: function() {
		},
		// 기관 정보 저장
		postAgency: async function() {
			try {
				await Axios.put(`${server.addr()}`+server.api.AGENCY, [this.agency]);
				this.$emit("refresh");
				this.$emit("close");
			} catch(e) {
				// TODO: error modal
			}
		},
		openAddressSearch: function() {
			window.open("/user/jusoPopup.jsp", "popAddressSearch", "width=570,height=420,scrollbars=yes,resizable=yes");
		},
		setAddress: function(zipcode, addr1, addr2) {
			this.agency.agencyAddr = addr1;
			this.agency.agencyDetailAddr = addr2;
			this.agency.agencyZipcode = zipcode;
		},
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>